// extracted by mini-css-extract-plugin
export default {"container":"banners_container__MidQe","heading":"banners_heading__xqRUH"};